/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type IconButtonPatientActions_Viewer = {
    readonly _id: string;
    readonly roles: ReadonlyArray<string | null> | null;
    readonly " $refType": "IconButtonPatientActions_Viewer";
};
export type IconButtonPatientActions_Viewer$data = IconButtonPatientActions_Viewer;
export type IconButtonPatientActions_Viewer$key = {
    readonly " $data"?: IconButtonPatientActions_Viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"IconButtonPatientActions_Viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IconButtonPatientActions_Viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roles",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '8e27ddbbcfcfc0df3217cc935fca6ff8';
export default node;
